import type { FC } from 'react';
import styled from 'styled-components';
import { Card } from '../../Card';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';
import { Icon, IconType } from '../../Props/Icon/Icon';

export const NoMandatoryTrainingsCard: FC = () => {
  return (
    <CardContainer>
      <Icon icon={IconType.GRADUATE_CAP} width={24} height={24} fill="transparent" />
      <DescriptionText>
        <NamedContentEntryText container={'span'} refKey={'yourTraining'} subKey={'noMandatoryTrainings'} />
      </DescriptionText>
    </CardContainer>
  );
};

const CardContainer = styled(Card)`
  background-color: ${({ theme }) => theme.colors.prototype.secondary};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  text-align: center;
  box-shadow: unset;
`;

const DescriptionText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.normal};
  color: ${({ theme }) => theme.colors.prototype.mutedForeground};
  font-weight: 400;
`;
